import { Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import { FitersserviceService } from '../../filters/filterspopup/fitersservice.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { FormControl, FormGroup } from '@angular/forms';
import { constants } from 'src/app/shared/common/contants';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionCheckBox } from 'src/app/shared/common/ActionCheckBox';
import { NgxUiLoaderService } from 'ngx-ui-loader';


export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  selectedValue: any
}

@Component({
    selector: 'app-rpm-search-filter',
    templateUrl: './rpm-search-filter.component.html',
    styleUrls: ['./rpm-search-filter.component.scss'],
    standalone: false
})
export class RpmSearchFilterComponent implements OnInit {

  @Input() s3FilePath;
  @Output() sendSelectedData=new EventEmitter();

  allocateButtonsBoolean = false;
  allocateButtons1Boolean=true;
  formValid: FormGroup;
  selectedProduct;
  productList;
  searchData;
  gridAPI;
  pageSize;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  columnDefs;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  components;
  defaultColDef;
  gridColumnAPI;
  backgroundColorButton = "";
  overlayNoRowsTemplate="";
  selectedRows:any=[];
  getdata: any = [];
  reportData: any;
  userid: any;
  fieldslist: any = {};
rowClassRules: any;

  noCompareFunction(){ return 0;}
  constructor(private service: FitersserviceService,private localStorageSettings: LocalStorageSettingsService,private constants: constants, @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,private spinner: NgxUiLoaderService,public dialogref: MatDialogRef<RpmSearchFilterComponent>,) { 

    this.components = {
      buttonRenderer: ActionCheckBox,
    }

    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }

  ngOnInit(): void {
    this.getAllRowsFromS3ExternalTable();
    this.formValid = new FormGroup({
      filter: new FormControl("", []),
    });
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection ="multiple";
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
  }

  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }
  
  onPageSizeChanged() {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }

  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }
 onSelectionChanged() {
    var selectedRows = this.gridAPI.getSelectedRows();
    console.log(selectedRows);
    console.log(selectedRows[0]);
    this.selectedRows=this.gridAPI.getSelectedRows();
    console.log(this.selectedRows);
    
   // this.senddata(selectedRows[0]);
  }
  async onGridReady(params) {
    let res: any
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    console.log(this.constants.ReportCreation)
    console.log(this.constants.UserColoumns)
    console.log(this.constants.userid)
   // this.getdata = await this.commonService.retrieveRecordService(this.constants.ReportCreation);
    this.getdata = this.data.edata;

    console.log()
    this.gridAPI.setGridOption('rowData', this.getdata);
   
// This code is used to select the rows by default
// for(let o=0;o<this.data.selectedValue.length;o++){
//   console.log(this.data.selectedValue[o])
//   this.gridAPI.forEachNode(node=>{
//     console.log(node.data.alias+"============="+this.data.selectedValue[o])
//     if(node.data.alias===this.data.selectedValue[o]){
//          node.setSelected(true)
//     }
//   })
// }
   
  }
  selectAll(e) {
    console.log(e)
    let d = {
      "userid": e.rowData.userid,
      "objectid": e.rowData.objectid,
      "datasetname": e.rowData.datasetname,
      "accesstype": e.rowData.accesstype,
      "fieldslist": e.rowData.fieldslist,
    }
    this.reportData = d
    console.log(this.reportData)
  }
  generateColumns(data: any[]) {

    console.log(data)
    let columnDefinitions = [];

    //creating the object for the action button
    let actionCol = {
          headerName: 'Select',
          headerTooltip: 'Select',
          tooltipValueGetter: (params) => 'Select/Unselect',
          field: 'chckBox',
          filter: false,
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly:true,
          cellRendererParams: { refresh: this.selectAll.bind(this), },
          width: 120,
          pinned: "left"
        }

    columnDefinitions.push(actionCol)

    //this is used to push all the keys and values present in the array
    data.map(object => {

console.log(object);
console.log(Object.keys(object));


      Object.keys(object).map(key => {

        if (key.indexOf('.') !== -1) {
          var k = key.split(".")
          var fieldValue = k[0] + " " + k[1]
          object[fieldValue] = object[key]
          let mappedColumn =
          {
            headerName: fieldValue,
            field: fieldValue,
            width: 180,
            filter: false,
            suppressToolPanel: true,
            headerTooltip: key, tooltipValueGetter: (params) => params.value,
            align: 'center',
            

          }
          columnDefinitions.push(mappedColumn);
        } else {
          console.log();
          
          if (Object.keys(object).includes("Risk_ID")) {
            let mappedColumn = {
              headerName: "Risk_ID",
              field: "Risk_ID",
              width: 180,
              filter: false,
              suppressToolPanel: true,
              headerTooltip: "Risk_ID", 
              tooltipValueGetter: (params) => params.value,
              align: 'center',
            };
            columnDefinitions.push(mappedColumn);
          }else if(Object.keys(object).includes("﻿Risk_ID")){
            let mappedColumn = {
              headerName: "﻿Risk_ID",
              field: "﻿Risk_ID",
              width: 180,
              filter: false,
              suppressToolPanel: true,
              headerTooltip: "﻿Risk_ID", 
              tooltipValueGetter: (params) => params.value,
              align: 'center',
            };
            columnDefinitions.push(mappedColumn);
          }
          if(key !== 'Risk_ID'){
            let mappedColumn2 =
            {
              headerName: key,
              field: key,
              width: 180,
              filter: false,
              suppressToolPanel: true,
              headerTooltip: key, tooltipValueGetter: (params) => params.value,
              align: 'center',
  
            }
            columnDefinitions.push(mappedColumn2);
          }
          
        }

      })
    })
    //Remove duplicate columns
    //since we have pushed empId,empName,zoneId,employeezoneId these all are present in the ..
    //..array which is pushed by the mappedColumn  but we are also adding them externally 
    //..to avoid duplicates we are removing the duplicates here
    columnDefinitions = columnDefinitions.filter((column, index, self) =>
      index === self.findIndex((colAtIndex) => (
        colAtIndex.field === column.field
      ))
    )

    return columnDefinitions;
  }
  getProductsData(){
    let data={
      "s3Path":"Non-Vault-Partner-si/Jraap/Datasets/case_product_quicksight/case_product_quicksight/part-00000-924aec43-d5e2-4de9-963b-263fdc267c66-c000.csv",
      "columnName":"Case_Product_Product_(product__v_name__v)",
      "tenantId":Number(this.localStorageSettings.getSettings("dnsName"))
    }
    this.spinner.start();
    this.service.getUniqueColumnData(data).subscribe(response=>{
      console.log(response);
      if(!response.error){
        this.productList=response;
      }
      this.spinner.stop();
    })
  }

  onProductSelectionChanged(event){
    console.log(event);
    this.getS3ExternalTableRowBasedOnProduct(event.value)
  }

  getAllRowsFromS3ExternalTable(){
    let data={
      "s3Path":this.s3FilePath,
      "tenantId":Number(this.localStorageSettings.getSettings("dnsName"))
    }
    this.spinner.start()
    this.service.getAllRowsFromS3File(data).subscribe(response=>{
      console.log(response);
      if(!response.error){
        this.getdata =response;

        console.log()
        this.gridAPI.setGridOption('rowData', this.getdata);
        console.log(this.getdata[0]);
        
        this.columnDefs=this.generateColumns([this.getdata[0]])
      }
      this.spinner.stop();
    })
  }
  getS3ExternalTableRowBasedOnProduct(product){
    let data={
      "s3Path":"Non-Vault-Partner-si/Jraap/Datasets/case_product_quicksight/case_product_quicksight/part-00000-924aec43-d5e2-4de9-963b-263fdc267c66-c000.csv",
      "columnName":"Case_Product_Product_(product__v_name__v)",
      "tenantId":Number(this.localStorageSettings.getSettings("dnsName")),
      "columnValue":product
    }
    this.spinner.start()
    this.service.getS3ExternalTableData(data).subscribe(response=>{
      console.log(response);
      if(!response.error){
        this.getdata =response;

        console.log()
        this.gridAPI.setGridOption('rowData', this.getdata);
        this.columnDefs=this.generateColumns(this.getdata)
      }
      this.spinner.stop();
    })
  }


  onQuickFilterChanged(event): void {
    console.log(event.target.value)
    this.searchData=event.target.value;
    this.gridAPI.setGridOption('quickFilterText',event.target.value)
  }
  senddata(){
  console.log(this.selectedRows);
  this.sendSelectedData.emit(this.selectedRows);
  }
  closePopup(){
    this.dialogref.close(null)
  }
}
